import type { ImageProps } from 'next/image';
import type { FC } from 'react';
import Image from 'next/image';

/**
 * 이미지 컴포넌트에 공통 옵션을 적용한 컴포넌트입니다.
 * 해당 컴포넌트에 속성을 변경할때는 꼭 해당 컴포넌트를 사용하는 모든 지면을 확인해주세요.(최대한 변경 x)
 *
 * default 속성
 *
 * fill: 이미지가 부모 요소의 크기에 맞게 확대/축소되어 채워집니다. 속성을 기본값으로 설정했으므로, 부모컴포넌트에 꼭 relative 속성을 추가해주세요.
 *
 * unoptimized: 디스크 캐시가 인스턴스별 중복생성하는 문제와
 * cpu 및 disk 사용률이 높아지는 관계로 이미지 최적화 기능 비활성화를 강제합니다.
 * 자세한 내용은 다음 링크를 참조하세요
 * @see {@link https://yanolja.atlassian.net/browse/YAWEB-2137}
 * */
export const BaseImage: FC<ImageProps> = (props) => {
  /**
   * fill:
   * */
  return <Image fill {...props} unoptimized />;
};
